module.exports = __webpack_public_path__ + "static/media/laptop.08fb8fb6.png";